exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-login-PasswordResetForm-form{width:250px;margin-left:auto;margin-right:auto;color:#15284b}.src-components-login-PasswordResetForm-form button{background-color:#15284b;border-color:#15284b}.src-components-login-PasswordResetForm-form button:hover{background-color:hsl(218.8888888889,56.25%,43.8235294118%);border-color:hsl(218.8888888889,56.25%,43.8235294118%)}.src-components-login-PasswordResetForm-form button{margin-bottom:10px}.src-components-login-PasswordResetForm-error{margin-top:10px;color:#ad1f2c}.src-components-login-PasswordResetForm-success{margin-top:10px;color:#15284b}", ""]);

// exports
exports.locals = {
	"form": "src-components-login-PasswordResetForm-form",
	"error": "src-components-login-PasswordResetForm-error",
	"success": "src-components-login-PasswordResetForm-success"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/login/PasswordResetForm/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/login/PasswordResetForm/styles.scss
// module chunks = 1